var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1H1l6.4 7.568V13.8l3.2 1.6V8.568z",
    stroke: "#AFAFB1",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcKICB3aWR0aD0iMThweCIKICBoZWlnaHQ9IjE3cHgiCiAgdmlld0JveD0iMCAwIDE4IDE3IgogIHZlcnNpb249IjEuMSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCj4KICAgIDxnCiAgICBpZD0i4pyFLUZlYXRoZXItKE5ldXRyYWwpIgogICAgc3Ryb2tlPSJub25lIgogICAgc3Ryb2tlLXdpZHRoPSIxIgogICAgZmlsbD0ibm9uZSIKICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgPgogICAgICAgIDxnCiAgICAgIGlkPSJWZXJzaWNoZXJ0ZS0tLUZpbHRlci1laW5nZWtsYXBwdCIKICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMDguMDAwMDAwLCAtMTI5LjAwMDAwMCkiCiAgICAgIHN0cm9rZT0iI0FGQUZCMSIKICAgICAgY2xhc3M9InRvZ2dsZSIKICAgICAgc3Ryb2tlLXdpZHRoPSIyIgogICAgPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEwOS4wMDAwMDAsIDEyOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJGaWx0ZXItSWNvbiIgcG9pbnRzPSIxNiAyIDAgMiA2LjQgOS41NjggNi40IDE0LjggOS42IDE2LjQgOS42IDkuNTY4IiAvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFilter as ReactComponent };